import PageLayout, { Section } from "./PageLayout";
import { ArrowUpRight, MapPin } from "lucide-react";

const ROLES = [
  { team: "Engineering", title: "Senior Frontend Engineer", location: "Remote · Africa-friendly TZ", type: "Full-time" },
  { team: "Engineering", title: "Streaming Backend Engineer (Go)", location: "Kinshasa · Hybrid", type: "Full-time" },
  { team: "Content", title: "Originals Producer — African Stories", location: "Lagos · On-site", type: "Full-time" },
  { team: "Design", title: "Senior Product Designer", location: "Remote", type: "Full-time" },
  { team: "Marketing", title: "Growth Marketing Manager", location: "Paris", type: "Full-time" },
  { team: "Data", title: "ML Engineer — Recommendations", location: "Remote", type: "Full-time" },
];

export default function Careers() {
  return (
    <PageLayout
      eyebrow="Careers"
      title="Build the next era of streaming."
      subtitle="We're a small, ambitious team with high standards, low ego and global ambition. If that sounds like you — read on."
      hero="https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1920&q=85"
    >
      <Section title="Why work here">
        <div className="grid sm:grid-cols-3 gap-4">
          {[
            { t: "Real ownership", d: "Equity for everyone, full stop." },
            { t: "Remote-first", d: "Work from anywhere with overlap to UTC+1/+2." },
            { t: "Top-tier comp", d: "Top-of-market salaries, generous PTO, learning budget." },
            { t: "Premium tools", d: "Best laptop, best monitors, best software, no questions." },
            { t: "Health & wellness", d: "Comprehensive insurance, mental health support." },
            { t: "African-first", d: "We invest in talent across the continent. Localized comp." },
          ].map((b, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
              <div className="font-bold mb-1.5" style={{ fontFamily: "Outfit" }}>{b.t}</div>
              <div className="text-sm text-[#aaa]">{b.d}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Open roles">
        <div className="space-y-2">
          {ROLES.map((r, i) => (
            <a key={i} href={`mailto:careers@djinostream.com?subject=Application: ${encodeURIComponent(r.title)}`} className="group flex items-center justify-between bg-[#0d0d0d] hover:bg-[#141414] border border-white/5 hover:border-[#E50914]/40 rounded-xl p-5 transition" data-testid={`role-${i}`}>
              <div>
                <div className="text-xs text-[#E50914] font-bold uppercase tracking-wider mb-1">{r.team}</div>
                <div className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>{r.title}</div>
                <div className="flex items-center gap-3 text-xs text-[#888] mt-1">
                  <span className="flex items-center gap-1"><MapPin size={12} />{r.location}</span>
                  <span>{r.type}</span>
                </div>
              </div>
              <ArrowUpRight className="text-[#888] group-hover:text-[#E50914] group-hover:rotate-12 transition" size={22} />
            </a>
          ))}
        </div>
        <p className="text-sm text-[#888] mt-6">Don't see a fit? <a className="text-[#E50914] hover:underline" href="mailto:careers@djinostream.com">careers@djinostream.com</a> — tell us what you'd build here.</p>
      </Section>
    </PageLayout>
  );
}
